import _isExtglob from "is-extglob";
var exports = {};

/*!
 * is-glob <https://github.com/jonschlinkert/is-glob>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */
var isExtglob = _isExtglob;

exports = function isGlob(str) {
  return typeof str === "string" && (/[*!?{}(|)[\]]/.test(str) || isExtglob(str));
};

export default exports;